module.exports = __webpack_public_path__ + "img/suwako moriya_sc2.81ad515c.png";